// ─────────────────────────────────────────────────────────────────────────────
// BRANDING — product naming, logos and login-page copy for the console.
//
// Colours, type, radius and shadows are NOT defined here (unlike xenquote's
// brand.ts): they come from the shared design tokens, 04-design-language/tokens.css,
// imported below. That file publishes the same --brand-* custom properties as
// xenquote's applyBrand(), under :root[data-theme="light"|"dark"], so the copied
// xenquote stylesheets (styles.css, shell.css, login.css…) work unchanged.
// ─────────────────────────────────────────────────────────────────────────────
import "../../04-design-language/tokens.css";
import "./console.css";

export const brand = {
  // Product naming: xenscope is the brand, "Commercial" the product line
  productName: "xenscope",
  productTag: "Commercial",
  legalName: "Synvu Limited",

  // Logos live in 20-console/public/brand/ (copied from 04-design-language/brand)
  logo: {
    icon: "/brand/xenscope-icon-no-text.webp", // two-leaf mark, works on both themes
    wordmarkDark: "/brand/logo-blue-text.webp", // slate "xenscope", for light theme
    wordmarkLight: "/brand/logo-white-text.webp", // white "xenscope", for dark theme
  },

  // Login page left-rail copy (02-positioning): we build business cases for prospecting,
  // we don't generate leads. "Its electricity use", not "actual": private properties' use is
  // estimated (BUILD-PLAN-PRIVATE-COMMERCIAL.md PC5.3)
  login: {
    headline: "The solar business case,\nbefore the first call.",
    tagline:
      "Properties that use a lot of electricity and generate none of it, each turned into a fully costed solar business case built on its electricity use, and exclusive to you.\nChoose your patch, order a report, and open the conversation with the numbers.",
    termsUrl: "https://xenscope.com/terms/",
    privacyUrl: "https://xenscope.com/privacy/",
  },
} as const;

/** Set the document title once; colours are already applied by the imported CSS. */
export function applyBrand(): void {
  document.title = `${brand.productName} ${brand.productTag}`;
}
